module.exports = __webpack_public_path__ + "media/images/vyskov-logo-2-011607a7.svg";